// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Button from 'grommet/components/Button';
import CheckBox from 'grommet/components/CheckBox';
import FormField from 'grommet/components/FormField';

import constants from '../../Constants';

var valueArr = [];
class DeepSensorControl extends Component {

  constructor(props) {
    super(props);
    this.state = {
      deepSensors: [],
      valueArr: []
    }
    this.valueChange = this.valueChange.bind(this);
  }
  componentWillMount() {
    let valueArr = [];
    let deepSensors = [];
    this.props.value.forEach((item, index) => {
      for (let key in item) {
        deepSensors[index] = {
          label: key,
          value: item[key]
        }
        valueArr[index] = {
          //label: key,
          [key]: item[key]
        }
      }
    });
    this.setState({
      deepSensors: deepSensors,
      valueArr: valueArr
    })
  }


  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillUnmount() {

  }

  valueChange(item, index, event) {
    valueArr = this.state.valueArr;
    valueArr[index] = {
      [item.label]: event.target.value
    }
    let controlInfo = {
      key: this.props.controlKey,
      controlType: this.props.controlType
    }
    this.props.controlValueChange(controlInfo, valueArr)
  }



  render() {

    return (
      <div className="item maxwidth">
        <div className="">{this.props.label}</div>
        {
          this.state.deepSensors.slice(0, 3).map((item, index) => {
            return (
              <div className="deepsensor" key={index}>
                <div className="label inlineblock">{item.label}</div>
                <div className="control inlineblock">
                  <input className="maxwidth" type="text" defaultValue={item.value} onChange={this.valueChange.bind(this, item, index)} />
                </div>
              </div>
            )
          })
        }

      </div>
    );
  }

}

export default DeepSensorControl;

/*<div className="deepsensor">
          <div className="label inlineblock">Deep Sensor2</div>
          <div className="control inlineblock">
            <input className="maxwidth" type="text" />
          </div>
        </div>
        <div className="deepsensor">
          <div className="label inlineblock">Deep Sensor2</div>
          <div className="control inlineblock">
            <input className="maxwidth" type="text" />
          </div>
        </div>*/


// WEBPACK FOOTER //
// ./src/js/components/site/DeepSensorControl.js